/*
 * SPDX-FileCopyrightText: © 2024 Schneider Electric
 *
 * SPDX-License-Identifier: Apache-2.0
 */

@import url('../shared.css');

:host {
  display: inline-block;
}

.qds-label {
  box-sizing: border-box;
  color: var(--qds-theme-control-text-standard);
  display: inline-flex;
  align-items: center;
  gap: var(--qds-text-icon-gap);
  width: 100%;

  &:focus-visible {
    outline: var(--qds-focus-border-width) solid var(--qds-theme-focus-border);
    outline-offset: var(--qds-focus-border-offset);
    border-radius: var(--qds-focus-border-radius);
  }
}

.qds-text {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
}

.qds-required {
  color: var(--qds-theme-feedback-field-required);
  user-select: none;
}

[data-size='small'] {
  &[data-importance='standard'] {
    font: var(--qds-form-small-text);
  }

  &[data-importance='emphasized'] .qds-text {
    font: var(--qds-form-small-text-emphasized);
  }

  &.qds-inline {
    margin-block: var(--qds-control-small-padding-auto-height);
  }

  &.qds-icon {
    height: var(--qds-form-small-icon-size);
    width: var(--qds-form-small-icon-size);
    min-width: var(--qds-form-small-icon-size);
  }
}

[data-size='standard'] {
  &[data-importance='standard'] {
    font: var(--qds-form-standard-text);
  }

  &[data-importance='emphasized'] .qds-text {
    font: var(--qds-form-standard-text-emphasized);
  }

  &.qds-inline {
    margin-block: var(--qds-control-standard-padding-auto-height);
  }

  &.qds-icon {
    height: var(--qds-form-standard-icon-size);
    width: var(--qds-form-standard-icon-size);
    min-width: var(--qds-form-standard-icon-size);
  }
}

[data-size='large'] {
  &[data-importance='standard'] {
    font: var(--qds-form-large-text);
  }

  &[data-importance='emphasized'] .qds-text {
    font: var(--qds-form-large-text-emphasized);
  }

  &.qds-inline {
    margin-block: var(--qds-control-large-padding-auto-height);
  }

  &.qds-icon {
    height: var(--qds-form-large-icon-size);
    width: var(--qds-form-large-icon-size);
    min-width: var(--qds-form-large-icon-size);
  }
}
